<template>
    <v-card class="elavation-1 rounded-4">
        <v-form @submit.prevent="savePublicNotification" ref="form">
            <v-toolbar flat height="45px">
                <span class="font-weight-bold">{{mode}} Company Announcements</span>
                <v-spacer></v-spacer>
                <v-btn icon @click="closeDialog">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text>
                <!-- category and types -->
                <v-layout row wrap>
                    <v-flex xs12 sm6 class="form-data">
                        <v-autocomplete
                            v-model="categoryId"
                            :disabled="disabled"
                            :items="categories"
                            :rules="[rules.required]"
                            chips
                            color="primary lighten-2"
                            label="Category"
                            item-text="name"
                            item-value="categoryId"
                            >
                            <template v-slot:selection="data">
                                <v-chip :selected="data.selected" dark :color="getChipColor()" class="chip--select-multi">
                                    {{ data.item.name }}
                                </v-chip>
                            </template>
                            <template v-slot:item="data">
                                <template v-if="typeof data.item !== 'object'">
                                    <v-list-tile-content v-text="data.item"></v-list-tile-content>
                                </template>
                                <template v-else>
                                    <v-list-tile-content>
                                        <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                                        <v-list-tile-sub-title v-html="data.item.group"></v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </template>
                            </template>
                        </v-autocomplete>
                    </v-flex>
                    <v-flex xs12 sm6 class="form-data">
                        <v-autocomplete
                            v-model="categoryTypeId"
                            :disabled="disabled||!categoryId"
                            :items="category_types"
                            :rules="[rules.required]"
                            chips
                            color="primary lighten-2"
                            label="Type"
                            item-text="name"
                            item-value="categoryTypeId"
                            >
                            <template v-slot:selection="data">
                                <v-chip :selected="data.selected" class="chip--select-multi">
                                    {{ data.item.name }}
                                </v-chip>
                            </template>
                            <template v-slot:item="data">
                                <template v-if="typeof data.item !== 'object'">
                                    <v-list-tile-content v-text="data.item"></v-list-tile-content>
                                </template>
                                <template v-else>
                                    <v-list-tile-content>
                                        <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                                        <v-list-tile-sub-title v-html="data.item.group"></v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </template>
                            </template>
                        </v-autocomplete>
                    </v-flex>
                </v-layout>

                <!-- effective and expirate dates -->
                <v-layout row wrap>
                    <v-flex xs12 sm6 class="form-data">
                            <v-layout row wrap>
                                <v-flex xs12 sm6>
                                    <v-menu v-model="menuEffectiveDateDay" :close-on-content-click="false" :nudge-right="40"
                                        lazy transition="scale-transition" offset-y full-width min-width="290px">
                                        <template v-slot:activator="{ on }">
                                            <v-text-field v-model="effectiveDateDay" label="Start Date" readonly v-on="on" :rules="[rules.required]" :disabled="disabled" hint="Event start date"></v-text-field>
                                        </template>
                                        <v-date-picker no-title v-model="effectiveDateDay" :allowed-dates="allowedDatesForEffectiveDate" @input="onEffectiveDateInput"></v-date-picker>
                                    </v-menu>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-menu
                                        ref="menuEffectiveDateTime"
                                        v-model="menuEffectiveDateTime"
                                        :close-on-content-click="false"
                                        :return-value.sync="effectiveDateTime"
                                        lazy
                                        transition="scale-transition"
                                        offset-y
                                    >
                                        <template v-slot:activator="{ on }">
                                        <v-text-field
                                            label="Time"
                                            v-model="effectiveDateTime"
                                            readonly
                                            v-on="on"
                                            :rules="[rules.required]"
                                            hint="Event start time"
                                        ></v-text-field>
                                        </template>
                                        <v-time-picker
                                            v-if="menuEffectiveDateTime"
                                            v-model="effectiveDateTime"
                                            full-width
                                            @click:minute="$refs.menuEffectiveDateTime.save(effectiveDateTime)"
                                            scrollable
                                            format="24hr"
                                        ></v-time-picker>
                                    </v-menu>
                                </v-flex>
                            </v-layout>
                    </v-flex>
                    <v-flex xs12 sm6 class="form-data">
                         <v-layout row wrap>
                            <v-flex xs12 sm6>
                                <v-menu v-model="menuExpirationDateDay" :close-on-content-click="false" :nudge-right="40"
                                    lazy transition="scale-transition" offset-y full-width min-width="290px">
                                    <template v-slot:activator="{ on }">
                                        <v-text-field v-model="expirationDateDay" label="End Date" readonly v-on="on" :rules="[rules.required]" :disabled="disabled||!effectiveDateDay" hint="Event end date"></v-text-field>
                                    </template>
                                    <v-date-picker no-title v-model="expirationDateDay" :allowed-dates="allowedDatesForExpiration" @input="menuExpirationDateDay = false"></v-date-picker>
                                </v-menu>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-menu
                                    ref="menuExpirationDateTime"
                                    v-model="menuExpirationDateTime"
                                    :close-on-content-click="false"
                                    :return-value.sync="expirationDateTime"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                >
                                    <template v-slot:activator="{ on }">
                                    <v-text-field
                                        label="Time"
                                        v-model="expirationDateTime"
                                        :disabled="disabled||!expirationDateDay"
                                        readonly
                                        v-on="on"
                                        :rules="[rules.required]"
                                        hint="Event end time"
                                    ></v-text-field>
                                    </template>
                                    <v-time-picker
                                        v-if="menuExpirationDateTime"
                                        v-model="expirationDateTime"
                                        full-width
                                        @click:minute="$refs.menuExpirationDateTime.save(expirationDateTime)"
                                        scrollable
                                        format="24hr"
                                    ></v-time-picker>
                                </v-menu>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>

                <!-- display start date, link -->
                <v-layout row wrap>
                    <v-flex xs12 sm3 class="form-data">
                        <v-menu v-model="menuDisplayStartDate" :close-on-content-click="false" :nudge-right="40"
                            lazy transition="scale-transition" offset-y full-width min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="displayStartDate" label="Display Date" readonly v-on="on" :rules="[rules.required]" :disabled="disabled||!expirationDateDay||!expirationDateDay" hint="When the announcement becomes visible"></v-text-field>
                            </template>
                            <v-date-picker no-title v-model="displayStartDate" :allowed-dates="allowedDatesForStartDate" @input="menuDisplayStartDate = false"></v-date-picker>
                        </v-menu>
                    </v-flex>
                    <v-flex xs12 sm9 class="form-data">
                        <v-text-field label="External Link (optional)"
                            v-model="detailsLink"
                            :disabled="disabled"
                            hint="Add an external URL to make the header clickable"
                            ></v-text-field>
                    </v-flex>
                </v-layout>

                <!-- recipient, display duration -->
                <v-layout row wrap>
                    <v-flex xs12 sm8 class="form-data">
                        <v-select
                            v-model="recipients"
                            :items="teams"
                            label="Recipient Teams"
                            :rules="[rules.required_multiple]"
                            :disabled="disabled"
                            item-text="name"
                            item-value="teamId"
                            multiple
                            chips
                        >
                            <!-- CUSTOM SELECTION DISPLAY -->
                            <template v-slot:selection="data">
                                <!-- If ALL selected → show only one chip -->
                                <v-chip
                                    v-if="allTeamsSelected && data.index === 0"
                                    class="chip--select-multi"
                                    dark
                                    color="primary"
                                >
                                    All Teams
                                </v-chip>

                                <!-- Hide other chips when ALL selected -->
                                <span v-else-if="allTeamsSelected"></span>

                                <!-- Default behavior if NOT all selected -->
                                <v-chip
                                    v-else
                                    :selected="data.selected"
                                    class="chip--select-multi"
                                >
                                    {{ data.item.name }}
                                </v-chip>
                            </template>

                            <!-- EXISTING prepend-item stays -->
                            <template v-slot:prepend-item>
                                <v-list-tile ripple @click="toggleAllTeams">
                                    <v-list-tile-action>
                                        <v-icon :color="recipients.length ? 'indigo darken-4' : ''">
                                            {{ selectAllIcon }}
                                        </v-icon>
                                    </v-list-tile-action>

                                    <v-list-tile-content>
                                        <v-list-tile-title>Select All</v-list-tile-title>
                                    </v-list-tile-content>
                                </v-list-tile>

                                <v-divider class="mt-2"></v-divider>
                            </template>
                        </v-select>
                    </v-flex>
                    <v-flex xs12 sm4 class="form-data mb-15">
                         <v-switch
                            v-model="displayDuration"
                            label="Show Dates in Banner"
                            color="primary"
                            hide-details
                        ></v-switch>
                        <span class="caption grey--text" v-if="displayDuration">Start and end dates are shown on the banner</span>
                        <span class="caption grey--text" v-else>Dates are hidden from the banner</span>
                    </v-flex>
                </v-layout>

                <!-- details -->
                <v-layout row wrap>
                    <v-flex xs12 sm12 class="form-data">
                        <v-textarea
                            v-model="details"
                            :rules="[rules.required]"
                            label="Announcement Details"
                            rows="2"
                            color="primary"></v-textarea>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="mr-20">
                <v-spacer></v-spacer>
                <v-btn v-if="mode=='Create'" title="Reset Form" @click="resetForm">Reset</v-btn>
                <v-btn title="Save" type="submit" class="primary" dark :loading="loading">Save</v-btn>
            </v-card-actions>
        </v-form>
    </v-card>
</template>
<script>

import companyAnnouncementsApi from '@/api/company-announcements'
import teamsApi from '@/api/team'

export default {
    data () {
        return {
            error: false,
            errorMessage: null,
            loading: false,
            disabled: false,
            search: null,
            rules: {
                required: value => !!value || 'Required field',
                required_multiple: value => value.length>0 || 'Must select at least one month.',
            },
            mode: '',
            menuEffectiveDateDay: false,
            menuEffectiveDateTime: false,
            menuExpirationDateDay: false,
            menuExpirationDateTime: false,
            menuDisplayStartDate: false,
            effectiveDateDay: null,
            effectiveDateTime: null,
            expirationDateDay: null,
            expirationDateTime: null,
            displayStartDate: null,
            displayDuration: false,
            recipients: [],
            categories: [],
            teams: [],
            companyAnnouncementsId: null,
            categoryId: null,
            categoryTypeId: null,
            details: null,
            detailsLink: null
        }
    },
    methods: {        
        toggleAllTeams() {
            this.$nextTick(() => {
                if (this.allTeamsSelected) {
                    this.recipients = []
                } else {
                    this.recipients = this.allTeamsValues.slice()
                }
            })
        },      
        allowedDatesForEffectiveDate(val) {
            return this.$moment(val).format('YYYY-MM-DD') >= this.$moment(new Date()).format('YYYY-MM-DD')
        },
        allowedDatesForExpiration(val) {
            return this.$moment(val).format('YYYY-MM-DD') >= this.$moment(this.effectiveDateDay).format('YYYY-MM-DD')
        },
        allowedDatesForStartDate(val) {
            return (this.$moment(val).format('YYYY-MM-DD') >= this.$moment(new Date()).format('YYYY-MM-DD') 
                    && this.$moment(val).format('YYYY-MM-DD') <= this.$moment(this.expirationDateDay).format('YYYY-MM-DD'))
        }, 
        onEffectiveDateInput() {
            this.menuEffectiveDateDay = false
            if (this.$moment(this.expirationDateDay).format('YYYY-MM-DD') < this.$moment(this.effectiveDateDay).format('YYYY-MM-DD')) {
                this.expirationDateDay = null
            }
            if (this.$moment(this.displayStartDate).format('YYYY-MM-DD') < this.$moment(this.effectiveDateDay).format('YYYY-MM-DD')) {
                this.displayStartDate = null
            }
        },
        getChipColor() {
            if (this.categoryId)
                return this.categories.filter(x => x.categoryId == this.categoryId)[0].backgroundColor
            return 'transparent'
        },
        async getTypes() {
            try {
                this.loading = true
                const response = await companyAnnouncementsApi.getCategories()
                if (response && response.status == 200) {
                    this.categories = response.data.items
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async getTeams() {
            try {
                this.loading = true
                const response = await teamsApi.getTeamsByCompany(false)
                if (response && response.status == 200) {
                    this.teams = response.data.items
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async savePublicNotification() {
            if (this.$refs.form.validate()) {
                try {
                    this.loading = true
                    this.disabled = true

                    const effectiveDateAndTime =
                        this.$moment(this.effectiveDateDay).format('YYYY-MM-DD') + ' ' +
                        this.effectiveDateTime

                    const expirationDateAndTime =
                        this.$moment(this.expirationDateDay).format('YYYY-MM-DD') + ' ' +
                        this.expirationDateTime

                    const data = {
                        companyAnnouncementsId: this.companyAnnouncementsId,
                        categoryId: this.categoryId,
                        categoryTypeId: this.categoryTypeId,
                        effectiveDate: effectiveDateAndTime,
                        expirationDate: expirationDateAndTime,
                        displayStartDate: this.displayStartDate,
                        displayDuration: this.displayDuration,
                        recipients: this.recipients,
                        details: this.details,
                        detailsLink: this.detailsLink
                    }

                    const response = await companyAnnouncementsApi.upsert(data)
                    if (response && response.status == 200) {
                        this.$emit('send', null)
                        this.closeDialog()
                    }
                    this.loading = false
                    this.disabled = false
                } catch(error) {
                    this.errorMessage = error
                    this.error = true
                }
            }
        },
        async setAdd() {
            this.mode = 'Create'
            
            if (!this.categories.length) {
                await this.getTypes()
            }
            
            if (!this.teams.length) {
                await this.getTeams()
            }
            
            this.companyAnnouncementsId = null
            this.$refs.form.reset()
        },
        async setEdit(data) {
            this.mode = 'Edit'

            if (!this.categories.length) {
                await this.getTypes()
            }

            if (!this.teams.length) {
                await this.getTeams()
            }

            this.companyAnnouncementsId = data.companyAnnouncementsId
            this.categoryId = data.categoryId
            this.categoryTypeId = data.categoryTypeId
            this.details = data.details
            this.detailsLink = data.detailsLink
            this.displayDuration = data.displayDuration
            this.recipients = data.recipients
            this.displayStartDate =  this.$moment(data.displayStartDate).format('YYYY-MM-DD')
            this.effectiveDateDay = this.$moment(data.effectiveDate).format('YYYY-MM-DD')
            this.effectiveDateTime = this.$moment(data.effectiveDate).format('HH:mm')
            this.expirationDateDay = this.$moment(data.expirationDate).format('YYYY-MM-DD')
            this.expirationDateTime = this.$moment(data.expirationDate).format('HH:mm')
        },
        closeDialog() {
            this.$emit('update:dialogAddEdit', false)
        },
        resetForm() {
            this.$refs.form.reset()
        },
    },
    created() {},
    computed: {
        category_types() {
             if (this.categoryId) {
                return this.categories.filter(x => x.categoryId == this.categoryId)[0].types
            }
        },
        allTeamsValues() {
            return this.teams.map(m => m.teamId)
        },
        allTeamsSelected() {
            return this.recipients.length === this.allTeamsValues.length
        },
        someTeamsSelected() {
            return this.recipients.length > 0 && !this.allTeamsSelected
        },
        selectAllIcon() {
            if (this.allTeamsSelected) return 'check_box'
            if (this.someTeamsSelected) return 'indeterminate_check_box'
            return 'check_box_outline_blank'
        },
    }
}
</script>
<style scoped>
.form-data {
    padding: 0px 20px 0px 20px;
}
</style>